import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Florida ePlan": {
    parameters: {
      linkUrls: ["https://tier2.erplan.net/onlinefiling/filingLogin.htm"],
      staffInputs: {
        fees: false,
        documentTypes: {
          receipt: true,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "ePlan",
    state: "FL",
  },
};
